/**
 * Canonical Krāsa — один справочник для PDP, галереи, фильтров, карточек.
 * Правки только здесь (+ зеркало snippets/color-normalizer.liquid, тот же алгоритм
 * по мере возможностей Liquid — см. docs/aioo-color-canonical.md).
 *
 * Контракт resolve(raw):
 *   { key, label, hex, hex2, hex3, title, isPattern }
 * hex2 !== null  → диагональный сплит hex/hex2 (два цвета в одном значении:
 *                  "Melna,Caurspīdīga", "Zaļa / Rozā", "Melna Zila").
 * hex3 !== null  → третий цвет, кружок-триптих (conic), напр. "Zaļa / Rozā / Brūna".
 * title          → подпись для тултипа: "Melna / Caurspīdīga".
 * isPattern      → штриховка поверх (принт без единого honest-цвета).
 * Двухцвет ≠ Melna: sameColor/uniqueCanonicalLabels различают solid и split.
 */
(function (window) {
  'use strict';

  function normKey(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  /* label = то, что видит покупатель; keys = точные/составные строки для поиска
     (подстрокой, самое длинное совпадение побеждает — порядок в массиве не важен). */
  var GROUPS = [
    { label: 'Dabīga Titāna', hex: '#b8b0a8', keys: ['dabiga titana'] },
    { label: 'Balta Titāna', hex: '#e8e6e1', keys: ['balta titana'] },
    { label: 'Caurspīdīga', hex: '#dce8f5', keys: ['caurspidiga', 'trn', 'transparent', 'clear', 'ledus'] },
    { label: 'Starlight', hex: '#f2ece3', keys: ['starlight', 'strlgt'] },
    { label: 'Melna', hex: '#1d1d1f', keys: ['melna', 'melns', 'black', 'pusnakts', 'astromelns'] },
    { label: 'Balta', hex: '#f5f5f7', keys: ['balta', 'balts', 'white'] },
    { label: 'Pelēka', hex: '#9ca3af', keys: ['peleka', 'peleks', 'gray', 'grey'] },
    { label: 'Grafīta', hex: '#4b4b4d', keys: ['grafita', 'astropeleks', 'space gray'] },
    { label: 'Sudraba', hex: '#c0c0c0', keys: ['sudraba', 'silver', 'zvaigznu'] },
    { label: 'Zelta', hex: '#d4af37', keys: ['zelta', 'gold'] },
    { label: 'Rozā Zelts', hex: '#e0a899', keys: ['roza zelts', 'rose gold'] },
    { label: 'Zila', hex: '#4a90d9', keys: ['zila', 'zils', 'blue'] },
    { label: 'Jūras Zila', hex: '#1e3a5f', keys: ['juras zila'] },
    { label: 'Tumši Zila', hex: '#2d5f8a', keys: ['tumsi zila', 'sierra zils', 'midnight blue'] },
    { label: 'Gaiši Zila', hex: '#7fb3e0', keys: ['gaisi zila', 'okeana zils', 'klusa okeana'] },
    { label: 'Tirkīza', hex: '#14b8a6', keys: ['tirkizzila', 'tirkiza', 'turquoise'] },
    { label: 'Piparmētru', hex: '#8fd9c4', keys: ['piparmetru', 'mint'] },
    { label: 'Sarkana', hex: '#e53935', keys: ['sarkana', 'sarkans', 'red', 'koralsarts', 'korallsarts', 'kirsu'] },
    { label: 'Burgundijas', hex: '#6d1a2f', keys: ['burgundijas', 'burgundy'] },
    { label: 'Sarkanbrūns', hex: '#8b3a2f', keys: ['sarkanbruns'] },
    { label: 'Violeta', hex: '#7e57c2', keys: ['violeta', 'violets', 'purple', 'purpura', 'lavandas'] },
    { label: 'Indigo', hex: '#3d3a80', keys: ['indigo'] },
    { label: 'Magenta', hex: '#e6007e', keys: ['magenta'] },
    { label: 'Zaļa', hex: '#34c759', keys: ['zala', 'zals', 'green', 'alpu zals', 'pusnakts zals', 'kaktusa', 'laims', 'lime'] },
    { label: 'Haki', hex: '#b7ab6b', keys: ['haki', 'khaki'] },
    { label: 'Olīvu', hex: '#6b6d38', keys: ['olivu', 'olive'] },
    { label: 'Rozā', hex: '#f8bbd0', keys: ['roza', 'pink', 'rozu'] },
    { label: 'Persiks', hex: '#f7b98b', keys: ['persiks', 'peach'] },
    { label: 'Dzeltena', hex: '#f5d042', keys: ['dzeltena', 'dzeltens', 'dzeltana', 'yellow', 'citrondzeltena', 'mustard'] },
    { label: 'Oranža', hex: '#ff9500', keys: ['oranza', 'orange'] },
    { label: 'Brūna', hex: '#8b6914', keys: ['bruna', 'brown', 'kafijas'] },
    { label: 'Bēša', hex: '#d9bf94', keys: ['besa', 'beza', 'beige'] },
    { label: 'Krēmkrāsas', hex: '#f2e8d5', keys: ['kremkrasas', 'cream'] },
  ];

  /* Дескрипторы принта/паттерна — не цвет, а сигнал "поверх есть узор/дизайн".
     Вырезаются из строки перед поиском honest-цвета, включают isPattern. */
  var PATTERN_MARKERS = ['ar dizainu', 'ar tekstu', 'miksēta', 'miksets', 'raiba', 'perlu'].map(normKey);

  var DEFAULT_HEX = '#d1d5db';

  /* Display names for the filter captions (Latvian label is the key). lv is the source
     of truth in GROUPS; en/ru are shown when <html lang> is en/ru. Unknown labels fall back to lv. */
  var NAMES = {
    en: {
      "Dabīga Titāna": "Natural Titanium",
      "Balta Titāna": "White Titanium",
      "Caurspīdīga": "Clear",
      "Starlight": "Starlight",
      "Melna": "Black",
      "Balta": "White",
      "Pelēka": "Gray",
      "Grafīta": "Graphite",
      "Sudraba": "Silver",
      "Zelta": "Gold",
      "Rozā Zelts": "Rose Gold",
      "Zila": "Blue",
      "Jūras Zila": "Ocean Blue",
      "Tumši Zila": "Dark Blue",
      "Gaiši Zila": "Light Blue",
      "Tirkīza": "Turquoise",
      "Piparmētru": "Mint",
      "Sarkana": "Red",
      "Burgundijas": "Burgundy",
      "Sarkanbrūns": "Maroon",
      "Violeta": "Purple",
      "Indigo": "Indigo",
      "Magenta": "Magenta",
      "Zaļa": "Green",
      "Haki": "Khaki",
      "Olīvu": "Olive",
      "Rozā": "Pink",
      "Persiks": "Peach",
      "Dzeltena": "Yellow",
      "Oranža": "Orange",
      "Brūna": "Brown",
      "Bēša": "Beige",
      "Krēmkrāsas": "Cream",
      "Daudzkrāsu": "Multicolor",
      "Ar rakstu": "Patterned",
      "Ar dizainu": "With design"
    },
    ru: {
      "Dabīga Titāna": "Натуральный титан",
      "Balta Titāna": "Белый титан",
      "Caurspīdīga": "Прозрачный",
      "Starlight": "Starlight",
      "Melna": "Чёрный",
      "Balta": "Белый",
      "Pelēka": "Серый",
      "Grafīta": "Графитовый",
      "Sudraba": "Серебряный",
      "Zelta": "Золотой",
      "Rozā Zelts": "Розовое золото",
      "Zila": "Синий",
      "Jūras Zila": "Морской синий",
      "Tumši Zila": "Тёмно-синий",
      "Gaiši Zila": "Голубой",
      "Tirkīza": "Бирюзовый",
      "Piparmētru": "Мятный",
      "Sarkana": "Красный",
      "Burgundijas": "Бордовый",
      "Sarkanbrūns": "Красно-коричневый",
      "Violeta": "Фиолетовый",
      "Indigo": "Индиго",
      "Magenta": "Маджента",
      "Zaļa": "Зелёный",
      "Haki": "Хаки",
      "Olīvu": "Оливковый",
      "Rozā": "Розовый",
      "Persiks": "Персиковый",
      "Dzeltena": "Жёлтый",
      "Oranža": "Оранжевый",
      "Brūna": "Коричневый",
      "Bēša": "Бежевый",
      "Krēmkrāsas": "Кремовый",
      "Daudzkrāsu": "Разноцветный",
      "Ar rakstu": "С узором",
      "Ar dizainu": "С дизайном"
    }
  };

  function localeCode() {
    var l = String((document.documentElement && document.documentElement.lang) || '').toLowerCase();
    return l.indexOf('ru') === 0 ? 'ru' : (l.indexOf('en') === 0 ? 'en' : 'lv');
  }

  /* "Melna / Caurspīdīga" -> each part translated separately. */
  function displayName(label, lang) {
    lang = lang || localeCode();
    var map = NAMES[lang];
    if (!map || !label) return label;
    return String(label).split(' / ').map(function (p) { return map[p] || p; }).join(' / ');
  }


  /* Один плоский список (needle, group), самая длинная строка побеждает —
     это одновременно даёт "точное совпадение" (короткие ключи для простых цветов)
     и "самое специфичное совпадение" (длинные составные ключи типа "juras zila"
     перебивают короткий "zila", не давая слить разные оттенки в одну семью). */
  var NEEDLES = [];
  GROUPS.forEach(function (g) {
    (g.keys || []).forEach(function (k) {
      NEEDLES.push({ needle: normKey(k), group: g });
    });
  });
  NEEDLES.sort(function (a, b) {
    return b.needle.length - a.needle.length;
  });

  /* Полный набор нормализованных однословных/составных ключей для проверки
     "является ли слово само по себе цветом" (для эвристики двухцветных пар без
     запятой типа "Melna Zila" — оба слова должны точно совпасть с ключом целиком,
     иначе это не два цвета, а одно составное название типа "Rozā Zelts"/"Gaiši Zila"). */
  var EXACT_WORD_MAP = {};
  GROUPS.forEach(function (g) {
    (g.keys || []).forEach(function (k) {
      var nk = normKey(k);
      if (nk.indexOf(' ') === -1) {
        EXACT_WORD_MAP[nk] = g;
      }
    });
  });

  function findByLongestSubstring(key) {
    if (!key) return null;
    for (var i = 0; i < NEEDLES.length; i++) {
      if (key.indexOf(NEEDLES[i].needle) !== -1) {
        return NEEDLES[i].group;
      }
    }
    return null;
  }

  function stripPatternMarkers(key) {
    var isPattern = false;
    PATTERN_MARKERS.forEach(function (marker) {
      if (key.indexOf(marker) !== -1) {
        isPattern = true;
        key = key.split(marker).join(' ');
      }
    });
    return { key: key.replace(/\s+/g, ' ').trim(), isPattern: isPattern };
  }

  /* Резолвит один токен (уже разделённый по запятой/слэшу вызывающей стороной).
     Возвращает { groups: [group,...] (1 или 2, если внутри токена нашлось два
     самостоятельных цветовых слова без разделителя), isPattern }. */
  function resolveToken(raw) {
    var stripped = stripPatternMarkers(normKey(raw));
    var key = stripped.key;
    if (!key) return { groups: [], isPattern: stripped.isPattern };

    var words = key.split(' ');
    if (words.length >= 2) {
      var wordGroups = words.map(function (w) {
        return EXACT_WORD_MAP[w] || null;
      });
      if (wordGroups.every(Boolean)) {
        var uniq = [];
        wordGroups.forEach(function (g) {
          if (uniq.indexOf(g) === -1) uniq.push(g);
        });
        return { groups: uniq.slice(0, 2), isPattern: stripped.isPattern };
      }
    }

    var single = findByLongestSubstring(key);
    return { groups: single ? [single] : [], isPattern: stripped.isPattern };
  }

  function resolve(raw) {
    var rawStr = raw || '';
    var tokens = rawStr.split(/[,/]/);
    var isPattern = false;
    var groups = [];

    tokens.forEach(function (token) {
      var r = resolveToken(token);
      isPattern = isPattern || r.isPattern;
      r.groups.forEach(function (g) {
        if (groups.indexOf(g) === -1) groups.push(g);
      });
    });

    if (!groups.length) {
      return {
        key: normKey(rawStr),
        label: rawStr,
        hex: DEFAULT_HEX,
        hex2: null,
        hex3: null,
        title: rawStr,
        isPattern: isPattern,
        raw: rawStr,
        unknown: !isPattern,
      };
    }

    var primary = groups[0];
    var secondary = groups[1] || null;
    var tertiary = groups[2] || null;
    var title = groups
      .slice(0, 3)
      .map(function (g) { return g.label; })
      .join(' / ');
    return {
      key: normKey(primary.label),
      label: primary.label,
      hex: primary.hex,
      hex2: secondary ? secondary.hex : null,
      hex3: tertiary ? tertiary.hex : null,
      title: title,
      isPattern: isPattern,
      raw: rawStr,
    };
  }

  function swatchId(rawOrCanon) {
    var c = rawOrCanon && rawOrCanon.key !== undefined ? rawOrCanon : resolve(rawOrCanon);
    return (c.key || '') + '|' + (c.hex2 || '') + '|' + (c.hex3 || '');
  }

  function sameColor(a, b) {
    if (!a || !b) return false;
    return swatchId(a) === swatchId(b);
  }

  function uniqueCanonicalLabels(rawList) {
    var seen = {};
    var out = [];
    (rawList || []).forEach(function (raw) {
      var c = resolve(raw);
      if (!c.key) return;
      var id = swatchId(c);
      if (seen[id]) return;
      seen[id] = true;
      out.push(c.hex2 ? c.title : c.label);
    });
    return out;
  }

  window.AIOO_COLOR = {
    GROUPS: GROUPS,
    normKey: normKey,
    resolve: resolve,
    swatchId: swatchId,
    sameColor: sameColor,
    uniqueCanonicalLabels: uniqueCanonicalLabels,
    displayName: displayName,
    localeCode: localeCode,
  };
})(window);
